import { defineComponent as _defineComponent } from 'vue'
import {nextTick, onMounted, ref} from "vue";
import statisticApi from "@/api/statistic";


export default /*#__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {

const {CodeToText, regionData} = require("@/js/region/region");

const dataList = ref([]);
const showForm = ref(false);
const screenHeight = document.documentElement.clientHeight;
const tableRef = ref();
const propParam = ref({
  publicDate: '',
  publicEndDate: '',
  regions: []
});

onMounted(() => {
  loadData();
});

const loadData = () => {
  statisticApi.listPromiseStatis({publicDate: propParam.value.publicDate, publicEndDate: propParam.value.publicEndDate, regions: propParam.value.regions.join(",")}).then((r: any) => {
    if (r.data.result === 0) {
      dataList.value = r.data.data;
      nextTick(() => {
        if(r.data.data){
          tableRef.value.toggleRowExpansion(r.data.data[0], true);
        }
      })
    }
  });
}

const reset = () => {
  propParam.value.publicDate = "";
  propParam.value.publicEndDate = "";
  propParam.value.regions = [];
  loadData();
}


return { __sfc: true,CodeToText, regionData, dataList, showForm, screenHeight, tableRef, propParam, loadData, reset }
}

})